import React, { useState, useEffect } from "react";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import YoutubeModal from "../custom/YoutubeModal";
import axiosStrapiInstance, { baseUrl } from "../../axiosStrapi";
import CustomButton from "../custom/CustomButton";
import CustomGalleryModal from "../custom/CustomGalleryModal";
import img1 from "../../assets/PositiveParentingImg1.jpeg";
import img2 from "../../assets/PositiveParentingImg2.jpeg";
import img3 from "../../assets/PositiveParentingImg3.jpeg";
import { toast } from "react-toastify";
import Loader from "../custom/Loader";

const parentingSeminars = [
  {
    img: img1,
    link: "https://www.youtube.com/embed/MMpfiusZzEQ",
  },
  {
    img: img2,
    link: "https://www.youtube.com/embed/_18da76sHtA",
  },
  {
    img: img3,
    link: "https://www.youtube.com/embed/4M9_TW4Xmow",
  },
];

const ParentingSeminar = () => {
  const [youtubeModal, setYoutubeModal] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  async function getParentingTips() {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        "/api/website-images?filters[Type][$eq]=ParentingTips&populate=*"
      );
      setImages(response?.data?.data[0]?.images);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      } else {
        toast.error("Login failed");
      }
    }
  }

  useEffect(() => {
    getParentingTips();
  }, []);
  return (
    <div className="flex flex-col gap-3 lg:py-[2%] py-[5%] px-[4%]">
      <CustomHeading
        text={"Parenting Seminars"}
        textSize={"70px"}
        textColor={"#D31C4F"}
        marginTop={window.innerWidth < 450 ? "0px" : "12px"}
        textAlign={"center"}
      />
      <CustomContent
        textColor="#111010"
        smText="20px"
        text={" Positive parenting is a way of life and Mrs. Sudha Gupta, the Honorary chairperson of Mother's Pride and Presidium schools, has been on the forefront of promoting and providing consistent guidance to parents to foster their children’s emotional well-being through enlightening parenting seminars. Her ardent efforts towards improving parent-child relationships have helped parents become more mindful and allowed their children thrive."}
        marginTop={window.innerWidth < 450 ? "10px" : "20px"}
        textAlign={window.innerWidth < 450 ? "left" : "justify"}
        textSize={"24px"}
        leading={window.innerWidth < 450 ? "34px" : "36px"}
      />
      <CustomContent
        textColor="#111010"
        textAlign={window.innerWidth < 450 ? "left" : "justify"}
        textSize={"24px"}
        leading={window.innerWidth < 450 ? "34px" : "36px"}
        text={
          "Mrs. Gupta conducts regular parenting seminars, which inspire parents to understand their child better. Her immense knowledge on parenting is shared in the form of weekly parenting tips. Thousands of parents are benefitting from these words of wisdom, which help them to inculcate right qualities in their kids to help them become the leaders of tomorrow."
        }
      />

      <div className="grid lg:grid-cols-3 grid-cols-1 sm:grid-cols-2 mt-[50px] flex-col gap-[4rem]">
        {parentingSeminars?.slice(0, 3)?.map((item, index) => (
          <div
            className="group relative cursor-pointer  lg:h-[400px] h-[250px]"
            onClick={() => {
              setYoutubeModal(true);
              setYoutubeUrl(item?.link);
            }}
            key={index}
          >
            <img
              src={item?.img}
              alt={`testimonial-${index}`}
              className="w-full lg:h-[400px] h-[250px] rounded-md cursor-pointer "
            />
            <div className="absolute rounded-md inset-0 group-hover:flex hidden items-center justify-center bg-black bg-opacity-50">
              <svg
                className="w-16 h-16 text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        ))}
      </div>
      <CustomButton
        text={"See All"}
        marginY={"25px"}
        marginX={"auto"}
        handleClick={() =>
          window.open(
            "https://www.youtube.com/user/ParentingExpertSG/videos",
            "_blank",
            "noreferrer",
            "noopener"
          )
        }
      />

      <CustomHeading
        text={"Positive Parenting Tips"}
        textSize={"70px"}
        textColor={"#D31C4F"}
        margin="my-[50px]"
        textAlign={"center"}
      />
      {loading ? (
        <Loader />
      ) : (
        <CustomGalleryModal
          images={images?.map((item) => `${item?.url}`)}
          paddingX={"0%"}
          paddingY={"0px"}
          objectFit={true}
        />
      )}

      {youtubeModal && (
        <YoutubeModal url={youtubeUrl} setOpenModal={setYoutubeModal} />
      )}
    </div>
  );
};

export default ParentingSeminar;
